module.exports = __webpack_public_path__ + "static/media/telegram-mac-os-screenshot-min.f443ca02.png";